// src/utils/character-filters.ts
var AFTN_STRICT_REGEX = /^[A-Z0-9 ()\-?:\/'.+=,]*$/;
var AFTN_SAFE_REGEX = /^[A-Za-z0-9 ()\-?:\/'.+=,]*$/;
var AFTN_STRICT_CHAR_REGEX = /[A-Z0-9 ()\-?:\/'.+=,]/;
var AFTN_SAFE_CHAR_REGEX = /[A-Za-z0-9 ()\-?:\/'.+=,]/;
var UPPERCASE_LETTERS_REGEX = /^[A-Z]*$/;
var ALPHANUMERIC_UPPER_REGEX = /^[A-Z0-9]*$/;
var DIGITS_ONLY_REGEX = /^[0-9]*$/;
var EMAIL_CHAR_REGEX = /[a-zA-Z0-9@._+-]/;
var PHONE_CHAR_REGEX = /[0-9+\-() ]/;
var URL_CHAR_REGEX = /[a-zA-Z0-9:/.?#&=@%_+~!$'()\-,;]/;
var characterFilters = {
  /**
   * AFTN Strict (uppercase only): A-Z, 0-9, space, ()-?:/'.+=,
   * Use for: Final AFTN message display/transmission
   */
  AFTN_STRICT: AFTN_STRICT_CHAR_REGEX,
  /**
   * AFTN Safe (allows lowercase): A-Z, a-z, 0-9, space, ()-?:/'.+=,
   * Use for: Form inputs and database storage
   */
  AFTN_SAFE: AFTN_SAFE_CHAR_REGEX,
  /**
   * Uppercase letters only: A-Z
   */
  UPPERCASE_LETTERS: /[A-Z]/,
  /**
   * Uppercase alphanumeric: A-Z, 0-9
   */
  ALPHANUMERIC_UPPER: /[A-Z0-9]/,
  /**
   * Digits only: 0-9
   */
  DIGITS_ONLY: /[0-9]/,
  /**
   * Email characters: a-z, A-Z, 0-9, @, ., _, +, -
   * Use for: Email input fields
   */
  EMAIL: EMAIL_CHAR_REGEX,
  /**
   * Phone characters: 0-9, +, -, (, ), space
   * Use for: Phone, mobile phone, and fax input fields
   */
  PHONE: PHONE_CHAR_REGEX,
  /**
   * URL characters: a-z, A-Z, 0-9, and common URL symbols
   * Use for: URL and external portal input fields
   */
  URL: URL_CHAR_REGEX,
  /**
   * All characters allowed (no filtering)
   * Use for: OAuth credentials, API keys, free-text secrets
   */
  ALL: /./
};
var isAftnStrictChar = (char) => {
  return AFTN_STRICT_CHAR_REGEX.test(char);
};
var isAftnSafeChar = (char) => {
  return AFTN_SAFE_CHAR_REGEX.test(char);
};
var isAftnStrict = (input) => {
  return AFTN_STRICT_REGEX.test(input);
};
var isAftnSafe = (input) => {
  return AFTN_SAFE_REGEX.test(input);
};
var toAftnStrict = (input) => {
  return input.toUpperCase().split("").filter(isAftnStrictChar).join("");
};
var sanitizeToAftnSafe = (input) => {
  return input.split("").filter(isAftnSafeChar).join("");
};
var getInvalidAftnChars = (input) => {
  return [...new Set(input.split("").filter((char) => !isAftnSafeChar(char)))];
};

export {
  AFTN_STRICT_REGEX,
  AFTN_SAFE_REGEX,
  AFTN_STRICT_CHAR_REGEX,
  AFTN_SAFE_CHAR_REGEX,
  UPPERCASE_LETTERS_REGEX,
  ALPHANUMERIC_UPPER_REGEX,
  DIGITS_ONLY_REGEX,
  EMAIL_CHAR_REGEX,
  PHONE_CHAR_REGEX,
  URL_CHAR_REGEX,
  characterFilters,
  isAftnStrictChar,
  isAftnSafeChar,
  isAftnStrict,
  isAftnSafe,
  toAftnStrict,
  sanitizeToAftnSafe,
  getInvalidAftnChars
};
